import Vue from 'vue'
import Router from 'vue-router'
import SliderBar from '@/components/SliderBar'
import Header from '@/components/Header'
import Home from '@/views/Dashboard/dashboard'
import Payment from '@/views/payment'
import Malware from '@/views/service/malware'
import Url from '@/views/service/url'
import App from '@/views/service/app'
import AppInsightDetail from '@/views/service/appInsightDetail'
import Wifi from '@/views/service/wifi'
import Junk from '@/views/service/junk'
import Whitelist from '@/views/service/whitelist'
import Settings from '@/views/settings/settings'
import Support from '@/views/support'
import Login from '@/views/user/login'
import ChangePass from '@/views/user/changePass'
import ForgotPass from '@/views/user/forgotPass'
import ResetPass from '@/views/user/resetPass'
import Register from '@/views/user/register'
import Tip from '@/views/user/tip'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login1',
      components: {
        header: '',
        menu: '',
        content: Login
      },
      meta: {
        title: 'Login - Trustlook SECaaS Dashboard',
        description:
          'Login Trustlook SECaaS dashboard to subscribe security services of malware detection, URL Filtering and App Insight.'
      }
    },
    {
      path: '/login',
      name: 'Login2',
      components: {
        header: '',
        menu: '',
        content: Login
      },
      meta: {
        title: 'Login - Trustlook SECaaS Dashboard',
        description:
          'Login Trustlook SECaaS dashboard to subscribe security services of malware detection, URL Filtering and App Insight.'
      }
    },
    {
      path: '/changePass',
      name: 'ChangePass',
      components: {
        header: '',
        menu: '',
        content: ChangePass
      }
    },
    {
      path: '/forgotPass',
      name: 'ForgotPass',
      components: {
        header: '',
        menu: '',
        content: ForgotPass
      },
      meta: {
        title: 'Forgot Password - Trustlook SECaaS Dashboard',
        description: 'Recover user password of Trustlook SECaaS dashboard'
      }
    },
    {
      path: '/resetPass',
      name: 'resetPass',
      components: {
        header: '',
        menu: '',
        content: ResetPass
      }
    },
    {
      path: '/tip',
      name: 'tip',
      components: {
        header: '',
        menu: '',
        content: Tip
      }
    },
    {
      path: '/dashboard',
      name: 'Home',
      components: {
        header: Header,
        menu: SliderBar,
        content: Home
      },
      meta: {
        title: 'Trustlook SECaaS Dashboard'
      }
    },
    {
      path: '/malware',
      name: 'Mobile Malware Detection',
      components: {
        header: Header,
        menu: SliderBar,
        content: Malware
      }
    },
    {
      path: '/url',
      name: 'URL Filtering',
      components: {
        header: Header,
        menu: SliderBar,
        content: Url
      }
    },
    {
      path: '/app',
      name: 'App Insight',
      components: {
        header: Header,
        menu: SliderBar,
        content: App
      }
    },
    {
      path: '/reportDetail',
      name: 'APP Insight Detail',
      components: {
        header: '',
        menu: '',
        content: AppInsightDetail
      }
    },
    {
      path: '/wifi',
      name: 'Android/iOS WiFi Security Detection',
      components: {
        header: Header,
        menu: SliderBar,
        content: Wifi
      }
    },
    {
      path: '/junk',
      name: 'Junk Clean',
      components: {
        header: Header,
        menu: SliderBar,
        content: Junk
      }
    },
    {
      path: '/whitelist',
      name: 'Whitelist',
      components: {
        header: Header,
        menu: SliderBar,
        content: Whitelist
      },
      meta: {
        requiresWhitelist: true
      }
    },
    {
      path: '/payment',
      name: 'Payment',
      components: {
        header: Header,
        menu: SliderBar,
        content: Payment
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      components: {
        header: Header,
        menu: SliderBar,
        content: Settings
      }
    },
    {
      path: '/register',
      name: 'Register',
      components: {
        header: '',
        menu: '',
        content: Register
      },
      meta: {
        title: 'Sign Up - Trustlook SECaaS Dashboard',
        description:
          'Sign Up Trustlook SECaaS dashboard to subscribe security services of malware detection, URL Filtering and App Insight.'
      }
    },
    {
      path: '/support',
      name: 'Support',
      components: {
        header: Header,
        menu: SliderBar,
        content: Support
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  /* Check whitelist permission for whitelist routes */
  if (to.meta.requiresWhitelist) {
    try {
      const response = await fetch('/api/user', {
        credentials: 'include'
      })
      if (response.ok) {
        const user = await response.json()
        if (!user.whitelist) {
          // User doesn't have whitelist permission, redirect to dashboard
          next('/dashboard')
          return
        }
      } else {
        // Not authenticated, redirect to login
        next('/')
        return
      }
    } catch (err) {
      console.error('Error checking whitelist permission:', err)
      next('/dashboard')
      return
    }
  }
  
  /* 路由发生变化修改页面 title,description,keywords */
  if (to.meta.title) {
    document.title = to.meta.title
    if (localStorage.getItem('lang') === 'zh') {
      if (to.meta.title === 'Login - Trustlook SECaaS Dashboard') {
        document.title = '登录 - Trustlook 安全服务云平台'
      }
      if (to.meta.title === 'Sign Up - Trustlook SECaaS Dashboard') {
        document.title = '注册 - Trustlook 安全服务云平台'
      }
      if (to.meta.title === 'Forgot Password - Trustlook SECaaS Dashboard') {
        document.title = '找回密码 - Trustlook 安全服务云平台'
      }
      if (to.meta.title === 'Trustlook SECaaS Dashboard') {
        document.title = 'Trustlook 安全服务云平台'
      }
    }
  }
  if (to.meta.description) {
    document.getElementById('descriptionId').content = to.meta.description
  } else {
    document.getElementById('descriptionId').content = ''
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js